import React from "react";
import Logo from "../../../UI/IconComponents/Logo";
import { useWeb3Form } from "../../../hooks/useWeb3Form";
import "./_Main.scss";

const ThanksSection = () => {
  const { onSubmit, result, submitting } = useWeb3Form("case-study");

  return (
    <div className="yaaaga__thanks-section">
      <div className="yaaaga__thanks-section-inner">
        <div className="yaaaga__thanks-section-top">
          <Logo size={80} />
          <span>
            <p>Thanks for watching!</p>
          </span>
        </div>
        <div className="yaaaga__thanks-section-lower">
          <span>
            <p>Let&apos;s talk about your project</p>
            <p className="text-small light-text font-medium ">
              Let&apos;s discuss your project and bring your ideas to life.
              Share your project details and let&apos;s get started!
            </p>
          </span>
          <form onSubmit={onSubmit}>
            <input type="checkbox" name="botcheck" className="form-botcheck" />
            <span>
              <input
                type="text"
                name="name"
                placeholder="Your name"
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your email"
                required
              />
              <textarea
                name="message"
                placeholder="Describe your project details here..."
                required
              />
              <button type="submit" disabled={submitting}>
                {submitting ? "Sending..." : "Send Message"}
              </button>
              {result && <p className="form-status form-status--thanks">{result}</p>}
            </span>
          </form>
        </div>
      </div>
      <span className="yaaaga__date">{new Date().getFullYear()}</span>
    </div>
  );
};

export default ThanksSection;
